import axios from 'axios';
import BaseComponent from 'scripts/BaseComponent.js';

export default class HatboxProductOption extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      json: '.js-filteredHatboxProductsJson',
    };

    this.dom = {
      $component: component,
    };

    this.state = {
      activeOptionClass: 'active-option',
      changeHatboxSizeEvent: 'changehatboxsize',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClickWithElement(dom.$component, this.handleSizeChange);
  }

  async handleSizeChange(btn) {
    const { state } = this;
    if (btn.classList.contains(state.activeOptionClass)) return;

    const { size, shape } = btn.dataset;
    const products = await this.fetchRelatedHatboxSizeProducts(size, shape);
    if (!products) return;

    this.dispatch(state.changeHatboxSizeEvent, { products });
  }

  async fetchRelatedHatboxSizeProducts(size, shape) {
    const { refs } = this;
    const url = `/collections/all?view=filtered-hatboxes&filter.p.m.custom.hatbox_shape=${shape}&filter.p.m.custom.hatbox_size=${size}`;

    try {
      const { data } = await axios.get(url);
      const parser = new DOMParser();
      const page = parser.parseFromString(data, 'text/html');
      const json = page.querySelector(refs.json);
      const hatboxData = JSON.parse(json.innerHTML);

      return hatboxData.products;
    } catch (e) {
      console.log('Error fetching related hatboxes', e);
      return null;
    }
  }
}
